import { render, staticRenderFns } from "./InformativaSintetica.vue?vue&type=template&id=99284e2e&scoped=true"
import script from "./InformativaSintetica.vue?vue&type=script&lang=ts"
export * from "./InformativaSintetica.vue?vue&type=script&lang=ts"
import style0 from "./InformativaSintetica.vue?vue&type=style&index=0&id=99284e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99284e2e",
  null
  
)

export default component.exports